import { render, staticRenderFns } from "./ScaleSettings.vue?vue&type=template&id=229f7bc9&"
import script from "./ScaleSettings.vue?vue&type=script&lang=js&"
export * from "./ScaleSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports